import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';

function ModalAlteracao({ titulo, visible, onAlterarCadastro, onCancel, loading, corpoModal, className }) {
  return (
    <Modal
      className={className || ''}
      visible={visible}
      title={titulo}
      onCancel={onCancel}
      closeable={false}
      width={650}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={onAlterarCadastro}
          loading={loading}
        >
          <CustomText color="white">Alterar valor</CustomText>
        </Button>,
        <Button
          key="back"
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </Button>,
      ]}
    >
      {corpoModal}
    </Modal>
  );
}

ModalAlteracao.propTypes = {
  titulo: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  onAlterarCadastro: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  corpoModal: PropTypes.node.isRequired,
  className: PropTypes.string,
};

ModalAlteracao.defaultProps = {
  visible: false,
  className: '',
};

export default ModalAlteracao;
